import ActionTypes from '../actions/types'

/**
 * @type {{residentsLookup: Object<string, {id: string, displayName: string}>}}
 */
const initialState = {
  residentsLookup: {}, // these objects have the props defined in ResidentFragment @see modelFragments.js
  hasLoadedResidentsAtBuilding: false,
}

function formatResidentObject(r) {
  // Ensure userProfileObj exists by parsing userProfile if needed
  if (!r.userProfileObj && r.userProfile) {
    try {
      r.userProfileObj = JSON.parse(r.userProfile || '{}')
    } catch (err) {
      r.userProfileObj = {}
    }
  }
  const userProfileObj = r.userProfileObj || {}
  return {
    ...r,
    displayName: `${r.displayName}${userProfileObj.goesBy ? ` '${userProfileObj.goesBy.trim()}'` : ''}`,
    canonicalDisplayName: r.displayName,
    userProfileObj, // Ensure this is always set
  }
}

// --------------------------------------------------------------------------------
// State permutation functions:

function reduceResidentsListToObj(state, residentsList) {
  let byId = {}
  residentsList.forEach(r => {
    byId[r.id] = formatResidentObject(r)
  })

  return {...state, residentsLookup: byId, hasLoadedResidentsAtBuilding: true}
}

function updateResident(state, resident) {
  const newLookup = {...state.residentsLookup}
  // overwrite changes only this is because Occupancy prop is merged into the resident on initial sync
  // and so will not appear in the updated resident object
  newLookup[resident.id] = {...newLookup[resident.id], ...formatResidentObject(resident)}
  return {...state, residentsLookup: newLookup}
}

// --------------------------------------------------------------------------------

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.BUILDINGS_SET_VIEWING:
      // when the building changes, we reset to initial state
      return {
        ...initialState,
      }

    case ActionTypes.RESIDENTS_UPDATE_ALL:
      return reduceResidentsListToObj(state, action.payload)

    case ActionTypes.RESIDENT_UPDATE_SINGLE:
      return updateResident(state, action.payload)

    default:
      return state
  }
}
